import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../../../utility/url.utility';
import previewDoc from '../../../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
import { format } from 'date-fns';
export default {
  name: 'Compliance',
  components: { previewDoc },
  props: [
    'partyRowDetails',
    'urlSummaryData',
    'workflowId',
    'dashboardDetails'
  ],
  data() {
    return {
      loader: false,
      isSuccess: false,
      showAlert: false,
      responseMsg: '',
      complianceData: [],
      complianceFields: [
        {
          key: 'id',
          label: 'Serial No.',
          stickyColumn: true
        },
        {
          key: 'iso_name',
          label: 'ISO Certificate Name'
        },
        {
          key: 'is_applicable'
        },
        { // 1.0 (Akhil kumar) Added a key detail for msme details
          key:'details',
          label:"Details"
        },
        {
          key:'data_msme',
          label:''
        },
        {
          key: 'expiry_date'
        },
        {
          key: 'original_file_name',
          label: 'File Name'
        },
        {
          key: 'file_name',
          label: 'Preview'
        }
      ],
      partyReqId: null,
      wfDtlId: null,
      eventId: null,
      approvalStatus: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      openKmAuth: null,
      dynamicData: null,
      currentPageIndex: null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false,
        newTab: true
      },
      msmeModalFlag:false,
      msmeNum:null,
      enterpriseType:null,
      enterpriseName:null,
      majorActivity:null,
      incorpDate:null,
      registrationDate:null,
      msmeEmail:null,
      udyamNumber:null,
      msmeVerId:0,
    };
  },
  mounted() {
    if (this.partyRowDetails) {
      this.partyReqId = this.partyRowDetails.req_id;
      this.wfDtlId = this.partyRowDetails.inprocess_dtl_id;
      this.eventId = this.workflowId.eventId;
    }
    if (this.urlSummaryData) {
      this.partyReqId = this.urlSummaryData.PARTY_REQ_ID;
      this.wfDtlId = this.urlSummaryData.wf_inprocess_dtl_id;
      this.eventId = this.urlSummaryData.wf_event_id;
    }
    if (this.dashboardDetails) {
      this.partyReqId = this.dashboardDetails.party_req_id;
    }
    this.getVendorComplianceDetails();
  },
  methods: {
    getVendorComplianceDetails() {
      const payload = {
        party_req_id: this.partyReqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getVendorComplianceDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.complianceData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken(docDtlId, fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            const url =
              this.downloadDocUrl +
              '/download/' +
              docDtlId +
              '?token=' +
              this.openKmAuth;
            commonHelper.downloadFile(url, fileName);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openPreviewDoc(flag, docDtlId, fileName, index, data) {
      const filterDynamicData = data.filter(a => a.original_file_name);
      const getFileName = data[index].original_file_name;
      for (let i = 0; i < filterDynamicData.length; i++) {
        if (filterDynamicData[i].original_file_name == getFileName) {
          this.currentPageIndex = i + 1;
          break;
        }
      }
      this.dynamicData = filterDynamicData;
      if (flag) {
        this.getOpenKmAuthTokenPreview(flag, docDtlId, fileName);
        // this.timeout = setTimeout(() => {
        //   // this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName); Previos Function
        //   this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
        // }, 1000);
      }
    },
    partOnboardingPreview(flag, docDtlId, authToken, fileName) {
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        // this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
        this.previewOpenDoc();
      }
    },
    previewOpenDoc() {
      this.fileExtension = commonHelper.getFileExtension(this.uploadedFileName);
      const payload = {
        docDetailId: this.docDtlId,
        token: this.authToken,
        fileExtension: this.fileExtension
      };
      this.loader = true;
      commonHelper.previewImgDocParty(payload);
      this.loader = false;
    },
    showHideOpenModal(flag, docDtlId, authToken, fileName) {
      // to open km modal
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
      }
    },
    getOpenKmAuthTokenPreview(flag, docDtlId, fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              // this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
              this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openMsmeModal(flag){
      this.msmeModalFlag=flag
      if(flag){
        this.accessButtons= {
          deleteAllow: false,
          downloadAllow: false,
          uploadAllow: false,
          editAllow: false,
          addAllow: false,
          printAllow: false,
          approvalAllow: false,
          newTab: false
        }
        this.getMsmeDetails()
      }
      // else{
      //   this.msmeNum=null
      // }
    },
    getMsmeDetails() {
      const payload = {
        party_req_id: this.partyReqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getMsmeDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            if(resp.data.data){
              const msmeData= JSON.parse(resp.data.data.msme_json)
              this.enterpriseType=msmeData.data.main_details.enterprise_type_list[0].enterprise_type;
              this.enterpriseName=msmeData.data.main_details.name_of_enterprise;
              this.majorActivity=msmeData.data.main_details.major_activity;
              this.incorpDate=format(new Date(msmeData.data.main_details.date_of_incorporation), 'dd-MMM-yyyy');
              this.registrationDate=format(new Date(msmeData.data.main_details.registration_date), 'dd-MMM-yyyy');
              this.msmeEmail=msmeData.data.main_details.email;
              this.udyamNumber=msmeData.data.uan;
              this.msmeVerId=resp.data.data.msme_ver_id
              }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
  // 1.0 (Akhil kumar) added function for show msme Data
  getMsmeData(flag){
    const payload = {
        partyReqId: this.partyReqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getMsmeDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            if(flag){
              this.msmeType = result.msme_type;
              this.msmeNumber = result.msme_no;
            }else{
              this.acceptanceDate = result.creation_date
              this.consentData = result.terms
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });

  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
